<template>
  <component :is="view()" />
</template>

<script>
export default {
  components: {},
  mounted() {
    document.body.classList.add('loaded', `page-${this.pageString}`)
    this.$util.event.create('ready')
  },
  unmounted() {
    this.$util.event.create('destroy')
  },
  computed: {
    pageUri() {
      return (this.$route.params.page || [404]).join('/')
    },
    pageString() {
      return (this.$route.params.page || [404]).join('-')
    }
  },
  methods: {
    view() {
      let pageUri = this.pageUri
        .replace(/^\w|-\w|\/\w/g, (letter) => {
          return letter.toUpperCase()
        })
        .replace(/-/g, '')
      let pageName = this.pageString
        .replace(/^\w|-\w/g, (letter) => {
          return letter.toUpperCase()
        })
        .replace(/-/g, '')
      if (this.$options.components[pageName] == undefined) {
        this.$options.components[pageName] = this.$util.requireOrNull(`/views/*.*/${pageUri}/Index.vue`)
        if (this.$options.components[pageName] === null) {
          this.$options.components[pageName] = this.$util.requireOrNull(`/views/404/Index.vue`)
        }
      }
      return pageName
    },
    changePage() {
      this.$store.commit('SET_DATA', {
        keys: ['main'],
        value: {}
      })
      document.body.className = document.body.className.replace(/\s*(page-[\w|-]*)\s*/g, '')
      document.body.classList.add(`page-${this.pageString}`)
    }
  },
  watch: {
    pageUri() {
      this.changePage()
    }
  }
}
</script>
